import { createRoot } from 'react-dom/client';

// Import polyfills first
import './lib/polyfills.ts';

// Typography
import '@fontsource-variable/inter';
import '@fontsource-variable/fraunces';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import App from './App.tsx';
import './index.css';

// Register the service worker for PWA/offline support.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Service worker registration is best-effort.
    });
  });
}

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
